import { ENV_NAME } from "../environment";
import type { DynamicsCaptureConfig, DynamicsCaptureMapping, DynamicsFormCaptureType } from "../types/dynamicsTypes";

export const getCaptureMappings = (type: DynamicsFormCaptureType): DynamicsCaptureMapping[] => {
   if (["main"].includes(type)) {
      return [
         {
            FormFieldName: "company",
            DataverseFieldName: "ava_parentaccountidstringvalue",
            label: "",
            hidden: true
         },
         {
            FormFieldName: "description",
            DataverseFieldName: "subject",
            label: "",
            hidden: true
         },
         {
            FormFieldName: "firstname",
            DataverseFieldName: "firstname",
            label: "Fornavn",
            validation: "mandatory"
         },
         {
            FormFieldName: "lastname",
            DataverseFieldName: "lastname",
            label: "Etternavn",
            validation: "mandatory"
         },
         {
            FormFieldName: "email",
            DataverseFieldName: "emailaddress1",
            label: "E-post",
            validation: "email"
         },
         {
            FormFieldName: "mobilephone",
            DataverseFieldName: "mobilephone",
            label: "Mobilnummer",
            validation: "phone"
         }
      ];
   }

   return [];
};

const isProd = ENV_NAME === "prod";
const dynamicsOrg = isProd ? "1e640fbe-4ea8-4ae5-a093-a84e6f604838" : "d266f74e-f7eb-43f2-8753-984c8a77eac6";
export const dynamicsEndpoint = `https://public-eur.mkt.dynamics.com/api/v1.0/orgs/${dynamicsOrg}/landingpageforms`;
export const scriptUrl = "https://formui-usa1.mkt.dynamics.com/eur/FormCapture/FormCapture.bundle.js";

export const getCaptureConfig = (type: DynamicsFormCaptureType): DynamicsCaptureConfig => {
   return {
      main: {
         FormId: isProd ? "51c954c1-e2cd-f111-a05c-0022489e9a12" : "ada86847-bac7-f111-aaad-70a8a557171f",
         FormApiUrl: dynamicsEndpoint
      }
   }[type];
};
